import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import MDButton from "../../components/MDButton";
import {CompanyContext} from "../../lib/CompanyContext";
import {changeCustomerLocation} from "../common/api/CustomerProfileApi";
import {useAccess} from "../../lib/AccessProvider";

export default function ClientChangeLocation({client, show, handleClose, handleSave}) {

  const [context, setContext] = useContext(AppContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [saving, setSaving] = useState(false);

  const handleChangeLocation = (location) => {
    setSaving(true);
    changeCustomerLocation(location.organizationId, client).then((resp)=>{
      handleSave();
      setSaving(false);
    })
  }

  const [orgAccess, setOrgAccess] = useState(null);
  const {getAccess} = useAccess();

  useEffect(()=> {
    setOrgAccess(getAccess());
  }, [])

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>

        <Modal.Header closeButton>
          <Modal.Title>Change Home Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <table className={'table table-striped table-hover'}>
                      <tbody>
                      {orgAccess?.orgChart?.parentOrganization && <tr className={'my-2'}>
                        <td sm={8}>
                          {orgAccess?.orgChart?.parentOrganization.organizationName}
                        </td>
                        <td className={'text-right'} sm={4}>
                          <MDButton className={'pull-right'} size="small" color="info" onClick={() => {
                            handleChangeLocation(orgAccess?.orgChart?.parentOrganization)
                          }}>
                            Assign
                          </MDButton>
                        </td>
                      </tr>}
                      {orgAccess?.orgChart?.childOrganizations?.map((org, idx) => {
                        return <tr key={idx} className={'my-2'}>
                          <td sm={8}>
                            {org.organizationName}
                          </td>
                          <td className={'text-right'} sm={4}>
                            <MDButton className={'pull-right'} size="small" color="info"
                                      onClick={() => {
                                        handleChangeLocation(org);
                                      }}>
                              Assign
                            </MDButton>
                          </td>
                        </tr>
                      })}
                      {orgAccess?.orgChart?.siblingOrganizations?.map((org, idx) => {
                        return <tr key={idx} className={'my-2'}>
                          <td sm={8}>
                            {org.organizationName}
                          </td>
                          <td className={'text-right'} sm={4}>
                            <MDButton className={'pull-right'} size="small" color="info"
                                      onClick={() => {
                                        handleChangeLocation(org);
                                      }}>
                              Assign
                            </MDButton>
                          </td>
                        </tr>
                      })}
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>


        </Modal.Body>
        <Modal.Footer>
          <MDButton onClick={handleClose} color="info" disabled={saving}>
            Close
          </MDButton>
        </Modal.Footer>
    </Modal>
  );
}